import styled from 'styled-components';
import {BGImageCenter, dFlexCenter, mobileMedia, SHADOW_COLOR, WHITE, DEFAULT_COLOR, DARK_SHADOW_COLOR} from '../../../globalVariables/GlobalVariables';
import * as Symbol from '../../../assets/symbols/symbols/Symbols.css';
import zIndex from '../../../globalVariables/zIndex';

export const LINE_MARGIN = 8;

export const basicRow=styled.div`
    box-shadow:0px 1px 4px ${SHADOW_COLOR};
    border-radius: 5px;
    margin: ${LINE_MARGIN}px 2px 0 2px;
    transition: height 0.3s;
`;

export const placeForDrag = styled.div`
    width:0;
    transition:all 300ms ;
`;

export const wrap = styled.div`
    position: relative;
    opacity: ${p => p.isDragging ? 0 : 1};
    transition: opacity 0.2s ease;
`;

export const row = styled(basicRow)`
    display: flex;
    height: ${p => p.rowHeight}px;
    align-items: center;
    box-shadow:${p => (p.isDragging ? `0px 8px 14px ${DARK_SHADOW_COLOR}` : `0px 1px 4px ${SHADOW_COLOR}`)} ;
    border-radius: 5px;
    background-color: ${WHITE};
    transform: ${p => p.transformValue || (p.isDragging ? 'scale(1.1)' : 'unset')};
    transition: ${p => p.transitionValue || 'transform 300ms, box-shadow 300ms, height 0.3s'};
    cursor: ${p => (p.isDragging ? 'grabbing' : 'grab')};
    z-index: ${p => p.zIndexValue || 'auto'};

    &.checked {
        box-shadow: 0 0 0 2px ${DEFAULT_COLOR};
    }

    &:hover {
        .dragSign {
            width: 30px;
            margin-inline-end: -30px;
            z-index: ${zIndex.baseHigh};
        }
        .place {
            width: 30px;
        }
        .row_icon {
            border-radius: unset;
        }
    }
`;

export const select = styled.div`
    width:30px;
    height:100%;
    ${dFlexCenter}
`;

export const drag = styled.div`
    width: 0;
    height: 100%;
    transition: all 300ms;
    ${BGImageCenter(Symbol.drag, '15px')};
    cursor: grab;
    ${mobileMedia} {
        width: 30px;
        position: absolute;
        &.select {
            width: 0;
        }
    }
`;
